import { useEffect, useState } from 'react'

/**
 * Hook to get the seconds left until a given date
 */
export const useSecondsCountdown = (countdownEndMs: number) => {
  const [secondsLeft, setSecondsLeft] = useState(
    Math.max((countdownEndMs - new Date().getTime()) / 1000, 0),
  )

  useEffect(() => {
    const interval = setInterval(() => {
      const millisecondsLeft = countdownEndMs - new Date().getTime()
      if (millisecondsLeft <= 0) {
        clearInterval(interval)
        setSecondsLeft(0)
      } else {
        setSecondsLeft(millisecondsLeft / 1000)
      }
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [countdownEndMs])

  return { secondsLeft }
}
